import React from "react";

const AppLabelsContext = React.createContext();

export const AppLabelsProvider = AppLabelsContext.Provider;
export const AppLabelsConsumer = AppLabelsContext.Consumer;

export default AppLabelsContext;
